import * as R from 'ramda'
import { connect } from 'react-redux'
import { compose, mapProps, withHandlers, lifecycle } from 'recompose'
import { showValidationSelector } from './selectors'
import { HocValidate as validate } from 'components/fulcrum/validation/index'
import {
  registerElement
} from './actions'
import {
  getValueSelector
} from 'containers/Form/Input/selectors'
import { isNotNull, isWithinRange, noValidation } from 'containers/Form/Util/Validation/predicates'
import { withValidationSagas as validationSagas } from './sagas'


const withValidation = (id) => {
  const showSelector = showValidationSelector(id)
  const mapStateToProps = (state) => {
    return {
      showError: showSelector(state),
    }
  }

  const mapDispatchToProps = dispatch => {
    return {
      registerElement: () => dispatch(registerElement(id))
    }
  }

  const withConnect = connect(mapStateToProps, mapDispatchToProps)

  const withElementRegistration = lifecycle({
    componentDidMount() {
      this.props.registerElement()
    }
  })

  return compose(
    withConnect,
    withElementRegistration
  )
}

const withError = mapProps(({ registerElement, showError, error, ...rest }) => ({
  error: showError ? error : '',
  ...rest,
}))

const withValidationError = R.curry((rules, id) => compose(
  withValidation(id),
  validate(rules),
  withError
))

const withFormValidation = R.curry((path, id, validation, Component) => {
  if (validation){
    let { type, range } = validation
    switch(type) {
      case 'is_not_null':
        const currentWithValidationNullCheck = withValidationError(isNotNull)
        const currentWithValidationNullCheckSagas = validationSagas(isNotNull)
        return(
          R.compose(
            currentWithValidationNullCheck(id),
            currentWithValidationNullCheckSagas(path, id, getValueSelector(path,id))
          )(Component)
        )
      case 'set_range':
        const currentWithValidationIntegerRange = withValidationError(isWithinRange(range, false))
        const currentWithValidationIntegerRangeSagas = validationSagas(isWithinRange(range, false))  
        return(
          R.compose(
            currentWithValidationIntegerRange(id),
            currentWithValidationIntegerRangeSagas(path, id, getValueSelector(path,id))
          )(Component)
        )
      case 'set_range_and_allow_null':
        const currentWithValidationRangeAndNull = withValidationError(isWithinRange(range, true))
        const currentWithValidationRangeAndNullSagas = validationSagas(isWithinRange(range, true))
        return(
          R.compose(
            currentWithValidationRangeAndNull(id),
            currentWithValidationRangeAndNullSagas(path, id, getValueSelector(path, id))
          )(Component)
        )
    } 
  } else {
    const noValidationCheck = withValidationError(noValidation)
    const noValidationCheckSagas = validationSagas(noValidation)

    return(
      R.compose(
        noValidationCheck(id),
        noValidationCheckSagas(path, id, getValueSelector(path, id))
      )(Component)
    )
  }
})

export { withValidationSagas } from './sagas'
export {
  withValidationError,
  withValidation,
  validate,
  withError,
  withFormValidation
}
